import { ROUTES } from "views/loyalty-app/app-loyalty-views/LoyaltyRoutes";
import messages from "./translations";

const routeToTitleMap = (route, formatMessage) => {
  switch (route) {
    case ROUTES.REWARDS:
      return formatMessage(messages.exclusiveOffersLabel);
    case ROUTES.PROFILE:
      return formatMessage(messages.profileLabel);
    case ROUTES.PROFILE_LEVEL:
      return formatMessage(messages.yourLevelLabel);
    case ROUTES.PROFILE_ACTIVITY:
      return formatMessage(messages.yourActivityLabel);
    case ROUTES.PROFILE_MEMBERSHIPS:
      return formatMessage(messages.yourMembershipsLabel);
    case ROUTES.APPOINTMENT_DETAILS:
      return formatMessage(messages.appointmentsLabel);
    case ROUTES.PROFILE_REWARDS:
      return formatMessage(messages.yourVouchersLabel);
    case ROUTES.DOCTORS:
      return formatMessage(messages.doctorsLabel);
    case ROUTES.SERVICES:
      return formatMessage(messages.servicesLabel);
    case ROUTES.INFO:
      return formatMessage(messages.infoLabel);
    case ROUTES.CONSENT_FORMS:
      return formatMessage(messages.consentFormsLabel);
    case ROUTES.CONSENT_FORM_VIEW:
      return formatMessage(messages.consentFormViewLabel);
    default:
      return formatMessage(messages.homeLabel);
  }
};

export default routeToTitleMap;
